import config from './config';

import createMainMenu, {
  MainRouteTable,
  spreadAndFillTheRest,
  createSinglePage,
  RouteTable,
  createMenu,
} from './utils/routeUtils';

import RootPage from 'src/pages/RootPage';
import LoginWithTempTokenOutside from 'src/layout/LoginWithTempToken';
import LogoutOutside from 'src/layout/Logout';
import SingleErrorPage from 'src/layout/SingleErrorPage';
import LoginOutside from 'src/layout/Login';
import RouteIcons from 'src/components/fxm/routeIcons';
// import { fxmManagerRootRouteTable, fxmManagerRouteTables } from './managerRoutes';
import ApprovalComplete from 'src/pages/users/approval/complete/ApprovalCompleteList';
import ApprovalPending from 'src/pages/users/approval/pending/ApprovalPendingList';
import LoginMain from 'src/layout/Login/LoginMain';

const fxmRootRouteTable: MainRouteTable = createMainMenu({
  path: '/',
  fullPath: config.url('/'),
  title: 'FXM',
  icon: RouteIcons.HomeIcon,
  // redirect: config.url('/approval/pending'),
  component: RootPage,
});

const fxmRouteTables: MainRouteTable[] = [
  createMainMenu({
    path: '/approval/',
    title: '메뉴',
    icon: RouteIcons.RequestCompleteIcon,
    subs: [
      createMenu({
        path: 'pending',
        title: 'userMenu:pending.title',
        // dividerTitle: 'userMenu:approval.$',
        // adminScopes: ['fxmuserui-approval-pending'],
        component: ApprovalPending,
      }),
      createMenu({
        path: 'complete',
        title: 'userMenu:complete.title',
        // adminScopes: ['fxmuserui-approval-complete'],
        component: ApprovalComplete,
      }),
    ],
  }),
];

// const routeTables: MainRouteTable[] =
//   import.meta.env.VITE_APP_TYPE === 'user'
//     ? fxmRouteTables
//     : import.meta.env.VITE_APP_TYPE === 'manager'
//     ? fxmManagerRouteTables
//     : [...fxmRouteTables, ...fxmManagerRouteTables];

// const rootRouteTable: MainRouteTable =
//   import.meta.env.VITE_APP_TYPE === 'user'
//     ? fxmRootRouteTable
//     : import.meta.env.VITE_APP_TYPE === 'manager'
//     ? fxmManagerRootRouteTable
//     : fxmRootRouteTable;

const routeTables: MainRouteTable[] = fxmRouteTables;
const rootRouteTable: MainRouteTable = fxmRootRouteTable;

const spreadRouteTables = routeTables.flatMap((rt) => spreadAndFillTheRest(rt, rootRouteTable));
const mainPageRouteTables = [...spreadRouteTables, rootRouteTable];

const singleRouteTable: RouteTable[] = [
  createSinglePage({
    path: '/main',
    fullPath: config.url('/main'),
    title: 'main',
    component: LoginMain,
    auth: false,
  }),
  createSinglePage({
    path: '/sign-in',
    fullPath: config.url('/sign-in'),
    title: 'Sign in',
    component: LoginOutside,
    auth: false,
  }),
  createSinglePage({
    path: '/sign-in-with-temp-token',
    fullPath: config.url('/sign-in-with-temp-token'),
    title: 'Sign in with token',
    component: LoginWithTempTokenOutside,
    auth: false,
  }),
  createSinglePage({
    path: '/sign-out',
    fullPath: config.url('/sign-out'),
    title: 'Sign out',
    component: LogoutOutside,
    auth: false,
  }),
  createSinglePage({
    path: '/errors/not-found',
    fullPath: config.url('/errors/not-found'),
    title: 'Not Found',
    component: SingleErrorPage.NotFoundOutside,
    auth: false,
  }),
  createSinglePage({
    path: '/errors/forbidden',
    fullPath: config.url('/errors/forbidden'),
    title: 'Forbidden',
    component: SingleErrorPage.ForbiddenOutside,
    auth: false,
  }),
];

export { routeTables, rootRouteTable, mainPageRouteTables, singleRouteTable };
